<template>
  <q-page padding>
    <div
        v-if="loadingMission"
        class="col items-center justify-center q-pa-lg q-gutter-md"
        >
        <div class="row justify-center">
          <q-spinner size="3em"  color="primary" />
        </div>
    </div>
    <template v-else>
      <MissionForm 
              v-model:mission="mission"
              button-label="Speichern"
              @update:date="updateDate"
              @onSubmit="update"
              />
    </template>
  </q-page>
</template>

<script>
  import MissionForm from '@/components/MissionForm.vue'
  import { getMission, updateMission } from '@/services/Missions.js'
  import { updateMissionDate } from '@/utils/useDateUtils.js'
  import { Notify } from 'quasar'
  import { apiErrorHandler } from '@/utils/apiErrorHandler.js'

  export default {
    components: { MissionForm },
    data() { 
      return {
        mission: {
          title: "",
          excerpt: "",
          description: "",
          start_date: "",
          end_date: "",
          team_set: []
        },
        loadingMission: true
      } 
    },
    mounted() {
      getMission( this.$route.params.id )
        .then( response => {
          this.mission = response
          this.loadingMission = false
        })
        .catch(apiErrorHandler("[MissionEdit] Mission laden"))
    },
    methods: {
      update() {
        updateMission( this.mission, this.$route.params.id )
          .then( () => {
            Notify.create( {
              message: "Änderungen gespeichert",
              type: "positive"
            } )
            this.$router.back() 
          })
          .catch(apiErrorHandler("[MissionEdit] Speichern", { fallbackMessage: "Fehler beim Speichern" }))
      },
      updateDate(d) {
        updateMissionDate(this.mission, d)
      }
    }
  }
</script>
